// src/theme/components.js
// Component-specific theme overrides for MUI components
// All comments in English only

export const components = {
  // Button component overrides
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none', // Disable uppercase transformation
        borderRadius: 3,
        fontWeight: 500,
        padding: '8px 16px',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-1px)',
          // Removed default hover shadow - use custom variables when needed
        },
      },
      contained: {
        boxShadow: 'none', // Remove default shadow
        '&:hover': {
          boxShadow: 'none', // Remove default hover shadow
        },
      },
      outlined: {
        borderWidth: 1.5,
        '&:hover': {
          borderWidth: 1.5,
        },
      },
    },
  },

  // AppBar component overrides
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: 'none', // Remove default shadow
        backdropFilter: 'blur(8px)',
        borderRadius: 0,
      },
    },
  },

  // Paper component overrides
  MuiPaper: {
    styleOverrides: {
      root: {
        boxShadow: 'none', // Remove default shadow
        borderRadius: 12,
      },
      elevation1: {
        boxShadow: 'none', // Remove default shadow
      },
      elevation2: {
        boxShadow: 'none', // Remove default shadow
      },
      elevation3: {
        boxShadow: 'none', // Remove default shadow
      },
    },
  },

  // TextField component overrides
  MuiTextField: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiOutlinedInput-root': {
          borderRadius: 8,
          '&:hover fieldset': {
            borderColor: theme.palette.primary.main,
          },
          '&.Mui-focused fieldset': {
            borderWidth: 2,
          },
        },
      }),
    },
  },

  // Card component overrides
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        boxShadow: 'none', // Remove default shadow
        transition: 'all 0.2s ease-in-out',
        // Removed default hover shadow - use custom variables when needed
      },
    },
  },

  // Typography component overrides
  MuiTypography: {
    styleOverrides: {
      h1: {
        fontWeight: 600,
        letterSpacing: '-0.01em',
      },
      h2: {
        fontWeight: 600,
        letterSpacing: '-0.01em',
      },
      h3: {
        fontWeight: 600,
        letterSpacing: '-0.01em',
      },
      h4: {
        fontWeight: 500,
        letterSpacing: '-0.01em',
      },
      h5: {
        fontWeight: 500,
        letterSpacing: '-0.01em',
      },
      h6: {
        fontWeight: 500,
        letterSpacing: '-0.01em',
      },
    },
  },
}; 